import axios from 'axios';

const BACKEND_URL = 'https://backend.eldenguee.com/solicitudes';

/**
 * Consulta el estado y valor del 1XBET ID de un usuario.
 */
export const getXbetId = async (username) => {
  if (!username) return { verified: false, xbet_id: null };
  try {
    const res = await axios.get(`${BACKEND_URL}/xbet-id/${encodeURIComponent(username)}`);
    return res.data;
  } catch (e) {
    console.error('Error fetching 1XBET ID:', e);
    return { verified: false, xbet_id: null };
  }
};

/**
 * Registra el 1XBET ID del usuario.
 * Es una acción única e inmutable (no puede ser cambiado luego).
 */
export const saveXbetId = async (username, xbetId) => {
  const res = await axios.post(`${BACKEND_URL}/xbet-id`, {
    nombre: username,
    xbet_id: xbetId,
  });
  return res.data;
};
